import React, { useState } from 'react';

export default (WrappedComponent) => (
  function WithSkipBankingSurveyState(props) {
    const [isSurveyOpen, setIsSurveyOpen] = useState(false);

    const handleSkipBanking = (didSkip) => {
      setIsSurveyOpen(false);
      if (didSkip) props.onSkipBanking(true);
    };

    return (
      <WrappedComponent
        {...props} // eslint-disable-line react/jsx-props-no-spreading
        isOpen={isSurveyOpen}
        onSkipButtonClick={() => setIsSurveyOpen(true)}
        onSkipBanking={handleSkipBanking}
      />
    );
  }
);
